/** 二要素页面曝光 */
export const TP_TWO_FACTOR_EXPOSE = 'finance_loan_twoElement_expose';

/** 二要素页面-"提交"点击 */
export const TP_TWO_FACTOR_SUBMIT = 'finance_loan_twoElement_submit';

/** 二要素页面_"提交信息错误"曝光 */
export const TP_TWO_FACTOR_SUBMIT_ERROR_POPUP_EXPOSE = 'finance_loan_twoElement_submit_errorPopUp';

/** 二要素页面_"提交信息错误"点击 */
export const TP_TWO_FACTOR_SUBMIT_ERROR_POPUP_CLICK = 'finance_loan_twoElement_submit_errorPopUp';

/** 联系人导入页面-"图标"点击/曝光 */
export const TP_CONTACT_IMPORT_ICON = 'finance_loan_personalInformation_contactImport';

/** 通信录导入授权弹窗弹窗 */
export const TP_CONTACT_IMPORT_POPUP = 'finance_loan_personalInformation_contactImport_authPopup';

/** 通讯录授权弹窗确认 */
export const TP_CONTACT_IMPORT_POPUP_CONFIRM = 'finance_loan_personalInformation_contactImport_authPopup_confirm';

/** 通讯录授权弹窗取消 */
export const TP_CONTACT_IMPORT_POPUP_CANCEL = 'finance_loan_personalInformation_contactImport_authPopup_cancel';

/** 通讯录导入成功，反显至输入框 */
export const TP_CONTACT_IMPORT_SUCCESS = 'finance_loan_personalInformation_contactImport_importSuccess';
